import { useQuery } from "react-query";
import api from "../services/api";
import { useActiveCompany } from "./useActiveCompany";
import { useActiveUser } from "./useActiveUser";

export const useApplications = () => {
  const userId = useActiveUser();
  const activeCompany = useActiveCompany();

  return useQuery(
    [`applications-${userId}-${activeCompany}`, userId, activeCompany],
    () => api.fetchApplications(userId || -1, activeCompany || -1),
    {
      enabled: !!userId && !!activeCompany,
    }
  );
};
